var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoaderanimated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2,
    r: 0,
    fill: "#034f81"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: 0,
    calcMode: "spline",
    dur: "1s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
    repeatCount: "indefinite",
    values: "0;2;0;0"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2,
    r: 0,
    fill: "#034f81",
    transform: "rotate(45 12 12)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0.125s",
    calcMode: "spline",
    dur: "1s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
    repeatCount: "indefinite",
    values: "0;2;0;0"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2,
    r: 0,
    fill: "#034f81",
    transform: "rotate(90 12 12)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0.25s",
    calcMode: "spline",
    dur: "1s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
    repeatCount: "indefinite",
    values: "0;2;0;0"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2,
    r: 0,
    fill: "#034f81",
    transform: "rotate(135 12 12)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0.375s",
    calcMode: "spline",
    dur: "1s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
    repeatCount: "indefinite",
    values: "0;2;0;0"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2,
    r: 0,
    fill: "#034f81",
    transform: "rotate(180 12 12)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0.5s",
    calcMode: "spline",
    dur: "1s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
    repeatCount: "indefinite",
    values: "0;2;0;0"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2,
    r: 0,
    fill: "#034f81",
    transform: "rotate(225 12 12)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0.625s",
    calcMode: "spline",
    dur: "1s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
    repeatCount: "indefinite",
    values: "0;2;0;0"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2,
    r: 0,
    fill: "#034f81",
    transform: "rotate(270 12 12)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0.75s",
    calcMode: "spline",
    dur: "1s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
    repeatCount: "indefinite",
    values: "0;2;0;0"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2,
    r: 0,
    fill: "#034f81",
    transform: "rotate(315 12 12)"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: "0.875s",
    calcMode: "spline",
    dur: "1s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
    repeatCount: "indefinite",
    values: "0;2;0;0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderanimated);
export default __webpack_public_path__ + "static/media/loaderanimated.22bb1d8e6d02ba366fcd60515a5b5817.svg";
export { ForwardRef as ReactComponent };